"use strict";

var _defineProperty = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryParams = exports.fixedEncodeURIComponent = exports.getQueryStringParams = exports.resolve = exports.replaceParams = exports.deserialize = exports.paramsToString = exports.getGoogleMapsAddressLink = void 0;

exports.getGoogleMapsAddressLink = function (p) {
  var urlAddress = encodeURIComponent(p.street + " " + p.zip + " " + p.city + " " + p.country.name);
  var url = "https://www.google.com/maps/?q=" + urlAddress;
  return url;
};

exports.paramsToString = function (params) {
  return Object.keys(params).map(function (key) {
    return key + "=" + encodeURIComponent(params[key]);
  }).join("&");
};

exports.deserialize = function (str) {
  return str.split(",").reduce(function (r, item) {
    var arr = item.split("=");

    if (arr.length === 2) {
      var _arr = _slicedToArray(arr, 2),
          key = _arr[0],
          value = _arr[1];

      return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, key, value));
    } else return r;
  }, {});
};

exports.replaceParams = function (uri, params) {
  var curly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!params || !(typeof params === "object")) {
    return uri;
  }

  Object.entries(params).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (curly) {
      var regex = new RegExp("\\$\\{".concat(key, "\\}"), "g");
      uri = uri.replace(regex, value);
    } else uri = uri.replace(":".concat(key), value);
  });
  return uri;
};

exports.resolve = function (hostIn, pathIn) {
  var re = /^(.*)\/[^\/]*$/;
  var hostMatch = hostIn.match(re);
  var host = hostMatch && hostMatch[1];

  if ((host === "http:/" || host === "https:/") && !hostIn.endsWith("/")) {
    host = hostIn;
  }

  var reSlash = /^\/{0,1}(.*)$/;
  var pathMatch = pathIn.match(reSlash);
  var path = pathMatch && pathMatch[1];

  if (host && path) {
    return "".concat(host, "/").concat(path);
  } else return null;
};

exports.getQueryStringParams = function (query) {
  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query).split("&").reduce(function (params, param) {
    var arrSplit = param.split("=");

    var _arrSplit = _slicedToArray(arrSplit, 2),
        key = _arrSplit[0],
        value = _arrSplit[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
    return params;
  }, {});
};

exports.fixedEncodeURIComponent = function (str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return "%" + c.charCodeAt(0).toString(16);
  });
};

exports.getQueryParams = function (s) {
  if (!s || typeof s !== "string" || s.length < 2) {
    return new Map();
  }

  var a = s.substr(1).split("&").map(function (x) {
    var a = x.split("=");
    return [a[0], a[1]];
  });
  return new Map(a);
};